import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { Subscription } from 'rxjs';
import { ListAssigned } from 'src/app/web/interfaces/project/list/projectDetailsDto';
import { ApiServicePayment } from 'src/app/web/apis/ApiServicePayment';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';
import { Location } from '@angular/common';

export class listPay {

  id: number;
  date_pay: string;
  description: string;
  listPaymentPlayIntoInfo: any
  
}

export class listPaylist {

    hes: string;
    facture: string;
    facture_date: string;
  
  
}

export class infolistPay {

  id: number;
  title:string;
  money:string;
  amount:string;
  amount_percent:string;
  status:string;
  date_payment:string;
  idPay:string;
  hes:string;
  facture:string;
  facture_date:string;
  description:string;

}

@Component({
  selector: 'app-pay-into-finance',
  templateUrl: './pay-into-finance.component.html',
  styleUrls: ['./pay-into-finance.component.scss']
})
export class PayIntoFinanceComponent implements OnInit{


  title = "Datos"
  idProject: number;
  id: number;
  nameProject: string;
  paymentsform: FormGroup;
  projectStages: stageProject[] = [];
  developersTeam: ListAssigned[] = [];
  createPay: listPay;
  createPaylist: listPaylist;
  listAnexo: any[] = [];
  datos: infolistPay;
  listMoney: any[] = [];
  private apiService: ApiServicePayment;
  createPayForm: FormGroup;
  infoPayForm: FormGroup;
  idSubscription: Subscription;
  items!: FormArray;


  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService,
    private location: Location

  ) {

    this.route.params.subscribe((params) => {
      this.id = params['idPay'];
      this.idProject = params['idProject'];
      this.title = params['client']
    });
  }

  ngOnInit(): void {

    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });

    this.items = this.paymentsform.get("items") as FormArray

    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

    this.createPayForm = this.fb.group({
      id: [0],
      date_pay: [''],
      description: [''],
    });

    this.infoPayForm = this.fb.group({
      id: [0],
      date_reschedule: [''],
      description: [''],
    });

    this.apiService = new ApiServicePayment(this.http);

    let rs = JSON.parse(localStorage.getItem("info-mtn"));

    rs.map((dato) => {
      if (dato.id == this.id) {
        this.datos = dato;
      }
    })

  }
  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

  }

  eliminarCampo(index) {
  this.items.removeAt(index)
  }

  goBack() {
    this.location.back();
  }
 

  transformName(name: string): string {
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }



  formSubmit(): void {
    this.spinner.show();

    if (this.createPayForm.value.date_pay === '') {
      this.spinner.hide();

      Swal.fire({title: 'Debe seleccionar una fecha' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createPayForm.value.description === '') {
      this.spinner.hide();

      Swal.fire({title: 'Debe rellenar una descripción' ,text: '',icon: 'error',heightAuto: false});
      return;
    }


    this.createPay = new listPay();

    this.createPay.id = Number(this.id);
    this.createPay.date_pay = moment(this.createPayForm.value.date_pay).format("DD-MM-YYYY");
    this.createPay.description = this.createPayForm.value.description;
   
 
    this.createPay.listPaymentPlayIntoInfo = []


    for(let info of this.items.value){
      let payInfo = {
        hes: info['hes'],
        facture:info['facture'],
        facture_date: moment(info['facture_date']).format("DD-MM-YYYY")
      }
      this.createPay.listPaymentPlayIntoInfo.push(payInfo)
    }

 
    this.apiService.postService('payment-play-into', this.createPay)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title: 'Se ha pagado correctamente' ,text: '',icon: 'success',heightAuto: false})
            .then(() => [
              this.location.back()]);

        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}